<template>
  <v-sheet class="if-detaile-card">
    <div class="operation-flame">
      <v-btn small outlined @click="backList()" class="back-btn">
        <span class="txt">一覧へ戻る</span>
      </v-btn>
    </div>
    <v-col class="detaile">
      <div class="rslt-box">
        <div class="rslt-list">
          <v-list dense class="py-0">
            <v-list-item class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.infoKind }}</v-col>
                <v-col class="info-val">{{ dispInfo.infoKindName }}</v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.area }}</v-col>
                <v-col class="info-val">{{ dispInfo.areaName }}</v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.target }}</v-col>
                <v-col class="info-val">{{ dispInfo.target }}</v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.summaryType }}</v-col>
                <v-col class="info-val">{{ dispInfo.summaryCode }}</v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.announceTime }}</v-col>
                <v-col class="info-val">{{ dispInfo.announceTime }}</v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.summary }} </v-col>
                <v-col class="info-val">{{ dispInfo.summary }}</v-col>
              </v-row>
            </v-list-item>
            <v-list-item class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.body }}</v-col>
                <v-col class="info-val detail-line">{{
                  dispInfo.detail
                }}</v-col>
              </v-row>
            </v-list-item>
            <v-list-item v-if="relCd !== null" class="list-data px-1">
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.relationObs }}</v-col>
                <v-col class="info-val"
                  ><a
                    v-for="(obs, index) in dispInfo.relObs"
                    :key="index"
                    class="obs-nm"
                    @click="obsDetail(obs.obsrvtnPointFullCode)"
                    >{{ obs.obsNm }}</a
                  ></v-col
                >
              </v-row>
            </v-list-item>
            <v-list-item
              v-if="
                dispRelObs !== null &&
                  dispRelObs.length < 2 &&
                  relCd !== null &&
                  dispRelObs[0].upstreamObsrvtnPointFullCode !== null
              "
              class="list-data px-1"
            >
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.relationUpObs }}</v-col>
                <v-col class="info-val">
                  <a
                    @click="
                      obsDetail(dispRelObs[0].upstreamObsrvtnPointFullCode)
                    "
                    >{{ dispRelObs[0].altObsNm }}</a
                  >
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item
              v-if="
                dispRelObs !== null &&
                  dispRelObs.length < 2 &&
                  relCd !== null &&
                  dispRelObs[0].cameraScamId !== null
              "
              class="list-data px-1"
            >
              <v-row no-gutters>
                <v-col class="label">{{ resultLabel.cctvCamera }}</v-col>
                <v-col class="info-val">
                  <a
                    @click="
                      clickCctv(
                        dispRelObs[0].cameraSysId,
                        dispRelObs[0].cameraScamId,
                        dispRelObs[0].cameraOwnCd,
                        dispRelObs[0].cameraSysCamId
                      )
                    "
                    >{{ dispRelObs[0].cameraNm }}</a
                  >
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-col>
  </v-sheet>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  mixins: [mixin],
  data() {
    return {
      // 表示用お知らせ詳細
      dispInfo: {},
      dispRelObs: null,
      relCd: null,
      resultLabel: {
        infoKind: "お知らせ種別",
        area: "地方",
        target: "お知らせ対象",
        summaryType: "お知らせ分類",
        announceTime: "発表日時",
        summary: "概要",
        body: "本文",
        relationObs: "お知らせ対象観測所",
        relationUpObs: "代替観測所",
        cctvCamera: "参照カメラ",
      },
    };
  },
  mounted() {
    // URLパラメータ取得
    var urlParam = this.$route.query["infmgcd"];
    this.getInformationInfo(urlParam);
    // アクセスログ出力
    PageLog.log({
      page_log: "info_detail",
      device_sb: this.$store.state.app.mode,
      fc_flg: this.$store.getters["app/isFldCtl"],
    });
  },
  computed: {
    /**
     * お知らせ詳細
     */
    informationInfo: {
      get() {
        return this.$store.state.info.informationInfo;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return this.$store.state.info.infoParam;
      },
    },
  },
  watch: {
    // お知らせ詳細の変更の監視
    informationInfo() {
      this.setInformationInfo();
    },
  },
  methods: {
    backList() {
      let param = {
        infKnd: null,
        area: null,
        trgt: null,
        dvs: [],
      };
      if (this.reqParam) {
        param = {
          infKnd: this.reqParam.infoKind,
          area: this.reqParam.area,
          trgt: this.reqParam.target,
          dvs: this.reqParam.division,
        };
      }
      this.routerPushMbInfoList("/mb/info", param);
    },
    /**
     * お知らせ詳細取得
     */
    getInformationInfo(urlParam) {
      this.$store.dispatch("info/getInformationInfo", urlParam);
    },
    setInformationInfo() {
      if (!Object.keys(this.informationInfo).length) {
        // お知らせ管理番号に合致するお知らせ情報が見つからない場合は一覧に遷移する。
        this.backList();
      }
      // 変換後お知らせ詳細
      this.dispInfo = this.$store.getters["info/getInfo"];
      this.$nextTick().then(() => {
        this.dispRelObs = this.dispInfo.relObs;
        this.relCd = this.dispRelObs[0].obsrvtnPointFullCode;
      });
    },
    obsDetail(obsFcd) {
      let ofcCd = parseInt(obsFcd.substr(0, 5));
      let itmkndCd = parseInt(obsFcd.substr(5, 3));
      let obsCd = parseInt(obsFcd.substr(8, 5));
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: ofcCd,
        itmkndCd: itmkndCd,
        obsCd: obsCd,
      });
      // 画面遷移
      this.$store.commit("info/setInformationInfo", {});
      this.$store.commit("app/setContent", "");
      this.routerPushTm("/mb/tm");
    },
    clickCctv(sysId, scamId, ownCd, sysCamId) {
      let itmkndCd = 100;
      if (sysId == 1) {
        // 簡易カメラ
        itmkndCd = 200;
      }
      // カメラの情報をストアに格納
      this.$store.commit("Telemeter/setSelectedTmParamScam", {
        itmkndCd: itmkndCd,
        scamId: scamId,
        ownCd: ownCd,
        sysCamId: sysCamId,
      });
      // カメラ個別観測所へ遷移
      this.$store.commit("info/setInformationInfo", {});
      this.$store.commit("app/setContent", "");
      this.routerPushTmScam("/mb/tm");
    },
  },
};
</script>
<style lang="scss" scoped>
.obs-nm {
  margin-right: 4px;
}
.label {
  padding: 2px;
  margin-right: 2px;
  font-weight: 600;
  font-size: 0.7rem;
  max-width: 120px;
  background-color: #bee2f8;
}

.info-val {
  padding: 2px;
  font-size: 0.7rem;
}

.detail-line {
  white-space: pre-line;
}

.list-data {
  margin: 4px 0px 4px 0px;
  min-height: 0px;
}

.if-detaile-card {
  display: flex;
  flex-direction: column;
  border: solid 1px #ddd;
  height: 100%;
  .operation-flame {
    margin-top: 4px;
    .back-btn {
      margin-left: 8px;
      .txt {
        font-size: 0.75rem;
      }
    }
    .event-btn {
      margin-left: 8px;
      .txt {
        font-size: 0.75rem;
      }
    }
  }
  .detaile {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
    .rslt-box {
      position: relative;
      flex: 1;
      height: 100%;

      .rslt-list {
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        overflow-y: auto;
        overflow-x: hidden;
        .url {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
